// extracted by mini-css-extract-plugin
export default {"optionContainer":"option_optionContainer__TjEBk","startIconContainer":"option_startIconContainer__-eXPI"};